/** @jsx jsx */

import { format } from 'date-fns';

import { css, jsx } from '@emotion/core';
import { Text } from '@zapier/design-system';

import type { Version } from './types';

const Styles = {
  root: css`
    display: flex;
    flex-direction: column;
  `,
};

type Props = {
  version: Version;
};

function ColumnLastUpdated({ version }: Props) {
  return (
    <div css={Styles.root}>
      <Text type="Body1">
        {format(new Date(version.updatedAt), 'yyyy-MM-dd')}
      </Text>
      <Text color="UiPrimaryStrongest">
        <a href={`mailto:${version.authorEmail}`} target="_blank">
          {version.authorEmail}
        </a>
      </Text>
    </div>
  );
}

export default ColumnLastUpdated;
